const FF_CONTAINER = 'ffContainer';
const FF_INPUT = 'ffInput';

export { FF_CONTAINER, FF_INPUT };
